"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterstellarColonyShip = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
class InterstellarColonyShip extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.INTERSTELLAR_COLONY_SHIP,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SPACE],
            cost: 24,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.SCIENCE, 5)),
            metadata: {
                description: 'Requires that you have 5 Science tags.',
                cardNumber: '027',
                victoryPoints: 4,
            },
        });
    }
    play(player) {
        if (player.getTagCount(Tags_1.Tags.SCIENCE) < 5) {
            throw 'Requires 5 science tags.';
        }
        return undefined;
    }
    getVictoryPoints() {
        return 4;
    }
}
exports.InterstellarColonyShip = InterstellarColonyShip;
//# sourceMappingURL=InterstellarColonyShip.js.map